import { Card, CardContent } from "@/components/ui/card";
import { useNossaHistoria } from "@/hooks/useNossaHistoria";
import { Skeleton } from "@/components/ui/skeleton";

export function TeamGallery() {
  const { teamMembers, teamLoading } = useNossaHistoria();

  if (teamLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-96 w-full" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
      {teamMembers?.map((member, index) => (
        <Card key={index} className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
          <CardContent className="p-0">
            <div className="aspect-square relative overflow-hidden rounded-t-lg">
              <img
                src={member.name?.toLowerCase().includes('brenda') ? '/sorrindo-sem-note.jpg' : member.photo_url}
                alt={member.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                style={{ objectPosition: 'center 50%' }}
                onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/sorrindo-sem-note.jpg'; }}
              />
            </div>
            <div className="p-4 sm:p-6">
              <h3 className="text-lg sm:text-xl font-bold mb-1 text-gray-800">
                {member.name}
              </h3>
              <p className="text-green-600 font-medium mb-3 text-sm sm:text-base">
                {member.position}
              </p>
              <p className="text-gray-600 mobile-text leading-relaxed">
                {member.description}
              </p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}